module.exports = __webpack_public_path__ + "img/1535897819.27d93d22.jpg";